<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div v-if="FEATURE_BD_1890_OVERFLOW_WIDE_IMG" class="large-panel viewer" @click.stop>
                <div class="viewer__head">
                    <button class="transparent viewer__close-button" type="button" @click="$emit('close')">
                        <img class="viewer__close-icon" :src="require('@/assets/icon_clear.svg')" alt="close"/>
                    </button>
                </div>
                <div class="viewer__body">
                    <div class="viewer__image-container">
                        <img class="viewer__image" :src="imageSrc" alt="user upload image"/>
                    </div>
                </div>
            </div>
            <div v-else class="large-panel" style="height:525px" @click.stop>
                <div style="text-align:right">
                    <button class="transparent" type="button" @click="$emit('close')">
                        <img style="margin-top:5px;height:40px;padding-right:5px" :src="require('../assets/icon_clear.svg')"/>
                    </button>
                </div>
                <div style="text-align: center;">
                    <img style="height:470px;object-fit: scale-down;" :src="imageSrc"/>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {FEATURE_BD_1890_OVERFLOW_WIDE_IMG} from "@/components/feature_toggles/feature_toggle";

export default {
    props: ['imageSrc'],
    emits: ['close'],
    computed: {
        FEATURE_BD_1890_OVERFLOW_WIDE_IMG() {
            return FEATURE_BD_1890_OVERFLOW_WIDE_IMG;
        }
    }
}
</script>

<style scoped>
.viewer {
    display: flex;
    flex-direction: column;
    height: 525px;

    --modal-padding: 5px;
}

.viewer__head {
    flex: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: var(--modal-padding);

    .viewer__close-button {
        padding: 0;
        width: 40px;
        height: 40px;
    }

    .viewer__close-icon {
        height: 100%;
        width: 100%;
    }
}

.viewer__body {
    flex: 1;
    min-height: 0;
    padding: var(--modal-padding);

    .viewer__image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;

        .viewer__image {
            max-height: 100%;
            max-width: 100%;
            object-fit: scale-down;
        }
    }
}
</style>
